/**
 * Created by chenggong on 2018/3/30.
 */
export const userInfo = state => {
  return state.userInfo
}

export const token = state => {
  return state.userInfo.token
}

export const deparmentCode = state => {
  return state.userInfo.department_code
}



// WEBPACK FOOTER //
// ./src/store/getters.js